import React from 'react';
import propTypes from 'prop-types';

import './pick-props.scss';

import { LiveBadge } from './Picks';

import utils from '../../utils/utils';
import {
  fixturePropPicksEqual,
  getFixturePropConfigBasedOptions,
  hasFixturePropConfigBasedOptions,
} from '../../utils/fixturePropKind';

import _ from 'underscore';

/**
 * This component handles the View and thefunctionallity of the clicked pick
 * @param type              { String }
 * @param fixtureProp       { Object }
 * @param handlePick        { Function }
 * @param handleRemovePick  { Function }
 * @param isDisabled        { Boolean }
 * @param selectedValue     { Object }
 * @return Component
 */
const PickProp = ({
  breaking,
  entryId,
  type,
  fixtureProp,
  handlePick,
  handleRemovePick,
  isDisabled,
  selectedValue,
  maxPicks,
}) => {
  let isSelected = false;


  if (
    selectedValue !== undefined &&
    selectedValue !== -1 &&
    selectedValue.prop_id === fixtureProp.id
  ) {
    //  console.log('selectedValue', selectedValue)
    isSelected = selectedValue.pick === type;
  }
  let correctClass = null;
  if (type === 'under') {
    if ( selectedValue && selectedValue.pick === 'under' ) {
      if (fixtureProp.fixture.suspended !== 1 && fixtureProp.fixture.sort_status !== 1 && fixtureProp.winning_pick !== 'tie' && selectedValue.pick === fixtureProp.winning_pick ) {
        correctClass = 'gano';
      }
      if (fixtureProp.fixture.suspended !== 1 && fixtureProp.fixture.sort_status !== 1 && fixtureProp.winning_pick !== 'tie' && selectedValue.pick !== fixtureProp.winning_pick ) {
        correctClass = 'perdio';
      }
    }

    return (
      <label
        className={`prop-category ${type === 'home' ? 'local' : 'visitante'} ${isSelected ? 'selected' : ''} ${correctClass}`}
        value={type}
        htmlFor={`propPartido-${entryId}-${fixtureProp.id}-${type}`}
        style={{ position: 'relative' }}
      // onClick={() =>{ handlePick('pick_prop', fixtureProp.id, type )}}
      >
        <li className="li-prop">
          <div className="radio-container">
            <input
              id={`propPartido-${entryId}-${fixtureProp.id}-${type}`}
              disabled={isDisabled}
              name={`propPartido-${fixtureProp.id}`}
              type="radio"
              value={type}
              checked={isSelected}
              onChange={() => handlePick('pick_prop', fixtureProp.id, type)}
              onClick={() => handleRemovePick('pick_prop', fixtureProp.id, type)}
            />
            <div className={`radio-check ${isDisabled ? 'disabled' : ''}`}></div>
          </div>
          <div style={{ display: 'contents' }}>
            {fixtureProp.data_type === 'boolean' ? 'Si' : 'Menos de '} &nbsp; {breaking}
          </div>
        </li>
        {isSelected && !!fixtureProp.enabled && maxPicks !== null && (
          <i style={{ right: '-5px' }} className="ion-close-circled delete-pick"></i>
        )}
      </label>
    );
  } else if (type === 'over') {
    if ( selectedValue && selectedValue.pick === 'over' ) {
      if (fixtureProp.fixture.suspended !== 1 && fixtureProp.fixture.sort_status !== 1 && fixtureProp.winning_pick !== 'tie' && selectedValue.pick === fixtureProp.winning_pick ) {
        correctClass = 'gano';
      }
      if (fixtureProp.fixture.suspended !== 1 && fixtureProp.fixture.sort_status !== 1 && fixtureProp.winning_pick !== 'tie' && selectedValue.pick !== fixtureProp.winning_pick ) {
        correctClass = 'perdio';
      }
    }

    return (
      <label
        className={`prop-category  ${isSelected ? 'selected' : ''} ${correctClass}`}
        value={type}
        htmlFor={`propPartido-${entryId}-${fixtureProp.id}-${type}`}
        style={{ position: 'relative' }}
      // onClick={() =>{ handlePick('pick_prop', fixtureProp.id, type )}}
      >
        <li className="li-prop" style={{ justifyContent: 'flex-end', paddingRight: '1rem' }}>
          <div style={{ display: 'contents' }}>
            {fixtureProp.data_type === 'boolean' ? 'No' : 'Más de '} &nbsp; {breaking}
          </div>
          <div className="radio-container">
            <input
              id={`propPartido-${entryId}-${fixtureProp.id}-${type}`}
              disabled={isDisabled}
              name={`propPartido-${fixtureProp.id}`}
              type="radio"
              value={type}
              checked={isSelected}
              onChange={() => handlePick('pick_prop', fixtureProp.id, type)}
              onClick={() => handleRemovePick('pick_prop', fixtureProp.id, type)}
            />
            <div className={`radio-check ${isDisabled ? 'disabled' : ''}`}></div>
          </div>
        </li>
        {isSelected && !!fixtureProp.enabled && maxPicks !== null && (
          <i style={{ left: '-5px' }} className="ion-close-circled delete-pick"></i>
        )}
      </label>
    );
  }
};

const ConfigBasedPropsGrid = ({
  entryId,
  fixtureProp,
  fixtureId,
  options,
  getLogo,
  getNameTeam,
  handlePick,
  handleRemovePick,
  isDisabled,
  selectedValue,
  maxPicks,
}) => {
  const count = options.length;
  const gridTemplateColumns = `repeat(${count}, minmax(0, 1fr))`;

  return (
    <div
      className="props-config-based-grid row-no-padding no-margin-top"
      style={{ gridTemplateColumns }}
    >
      <div className="props-config-based-grid__header">
        <label className="props-config-based-grid__team props-config-based-grid__team--home">
          <li className="li-prop">
            {getLogo(fixtureId, true)} {getNameTeam(fixtureId, true)}
          </li>
        </label>
        <label className="props-config-based-grid__team props-config-based-grid__team--vs">
          <li className="li-prop">
            <b>VS</b>
          </li>
        </label>
        <label className="props-config-based-grid__team props-config-based-grid__team--away props-config-based-grid__cell-row-border-end">
          <li className="li-prop">
            {getNameTeam(fixtureId, false)} {getLogo(fixtureId, false)}
          </li>
        </label>
      </div>
      {options.map((option, idx) => {
        const isSelected =
          selectedValue !== undefined &&
          selectedValue !== -1 &&
          selectedValue.prop_id === fixtureProp.id &&
          fixturePropPicksEqual(selectedValue.pick, option.value);

        let correctClass = null;
        if (isSelected) {
          if (
            fixtureProp.fixture.suspended !== 1 &&
            fixtureProp.fixture.sort_status !== 1 &&
            fixtureProp.winning_pick !== 'tie' &&
            fixturePropPicksEqual(selectedValue.pick, fixtureProp.winning_pick)
          ) {
            correctClass = 'gano';
          }
          if (
            fixtureProp.fixture.suspended !== 1 &&
            fixtureProp.fixture.sort_status !== 1 &&
            fixtureProp.winning_pick !== 'tie' &&
            !fixturePropPicksEqual(selectedValue.pick, fixtureProp.winning_pick)
          ) {
            correctClass = 'perdio';
          }
        }

        const inputId = `propPartido-${entryId}-${fixtureProp.id}-opt-${idx}-${option.value}`;
        const isLastOpt = idx === count - 1;

        return (
          <label
            key={inputId}
            className={`props-config-based-grid__option prop-category ${isSelected ? 'selected' : ''} ${
              correctClass || ''
            } ${isLastOpt ? 'props-config-based-grid__cell-row-border-end' : ''}`}
            htmlFor={inputId}
            style={{ gridColumn: `${idx + 1} / ${idx + 2}`, gridRow: 2, position: 'relative' }}
          >
            <li className="li-prop props-config-based-grid__option-inner">
              <div className="radio-container">
                <input
                  id={inputId}
                  disabled={isDisabled}
                  name={`propPartido-${fixtureProp.id}`}
                  type="radio"
                  value={option.value}
                  checked={isSelected}
                  onChange={() => handlePick('pick_prop', fixtureProp.id, option.value)}
                  onClick={() => handleRemovePick('pick_prop', fixtureProp.id, option.value)}
                />
                <div className={`radio-check ${isDisabled ? 'disabled' : ''}`}></div>
              </div>
              <span className="option-prop-val">{option.label}</span>
            </li>
            {isSelected && !!fixtureProp.enabled && maxPicks !== null && (
              <i style={{ right: '-5px' }} className="ion-close-circled delete-pick"></i>
            )}
          </label>
        );
      })}
    </div>
  );
};

/**
 * This component renders the list of picks and props
 * @param fixtureProps            { Object }
 * @param handlePick              { Function }
 * @param handleRemovePick        { Function }
 * @param poolInfo                { Object }
 * @param updateStartedFixture    { Function }
 * @param myEntry                 { Object }
 */
const ListPicksProps = ({
  fixtures,
  fixtureProps,
  handlePick,
  handleRemovePick,
  poolInfo,
  updateStartedFixture,
  myEntry,
}) => {
  if (!fixtureProps || !myEntry) {
    return null;
  }

  let listTypes = [...new Set(fixtureProps.map((e) => e.name))];

  const getValue = (type, property) => {
    return fixtureProps.some((e) => e.name === type)
      ? fixtureProps.find((r) => r.name === type)[property]
      : '';
  };

  let groupTypesProps = listTypes.map((e) => {
    return {
      type: getValue(e, 'type'),
      name: getValue(e, 'name'),
      props: fixtureProps.filter((r) => r.name === e),
    };
  });

  const getPropsByGroup = (fixtprop) => {
    let selectedValue = _.find(myEntry.picks_props, (myPick) => {
      if (
        myPick.fixture_id === fixtprop.fixture_id &&
        myPick.prop_id === fixtprop.id &&
        myPick.pick !== null
      ) {
        return myPick;
      }
    });

    let isDisabled = !fixtprop.enabled || (utils.isLogged() && utils.isSuPick());

    const configBasedOptions = hasFixturePropConfigBasedOptions(fixtprop)
      ? getFixturePropConfigBasedOptions(fixtprop)
      : null;

    const getLogo = (idFixture, isHome) => {
      const fixture = fixtures.find((e) => e.id === idFixture); //

      if (!fixture) return <React.Fragment></React.Fragment>;

      if (isHome) {
        return <i className={`${fixture.home_team.logo} home`}></i>;
      } else {
        return <i className={`${fixture.away_team.logo} away`}></i>;
      }
    };

    const getNameTeam = (idFixture, isHome) => {
      const fixture = fixtures.find((e) => e.id === idFixture); //

      if (!fixture) return '';

      if (isHome) {
        return fixture.home_team.name;
      } else {
        return fixture.away_team.name;
      }
    };

    return (
      <div key={fixtprop.id} className="props-row flex-container justify align column">
        {fixtprop.fixture && (
          <div className="flex-row row-no-padding no-margin-top">
            <LiveBadge fixture={fixtprop.fixture} />
          </div>
        )}

        {configBasedOptions ? (
          <ConfigBasedPropsGrid
            entryId={myEntry.entry_id}
            fixtureProp={fixtprop}
            fixtureId={fixtprop.fixture_id}
            options={configBasedOptions}
            getLogo={getLogo}
            getNameTeam={getNameTeam}
            isDisabled={isDisabled}
            selectedValue={selectedValue}
            handlePick={handlePick}
            handleRemovePick={handleRemovePick}
            maxPicks={poolInfo.max_picks}
          />
        ) : (
          <React.Fragment>
            <div className={'props-data flex-row row-no-padding no-margin-top'}>
              <label>
                <li className={'li-prop'}>
                  {' '}
                  {getLogo(fixtprop.fixture_id, true)} {getNameTeam(fixtprop.fixture_id, true)}{' '}
                </li>
              </label>
              <label>
                <li className={'li-prop'}>
                  {' '}
                  <b>VS</b>{' '}
                </li>
              </label>
              <label>
                <li className={'li-prop'}>
                  {' '}
                  {getNameTeam(fixtprop.fixture_id, false)} {getLogo(fixtprop.fixture_id, false)}{' '}
                </li>
              </label>
            </div>
            <div className={'props-data flex-row row-no-padding no-margin-top'}>
              <PickProp
                entryId={myEntry.entry_id}
                fixtureProp={fixtprop}
                type={'under'}
                isDisabled={isDisabled}
                selectedValue={selectedValue}
                handlePick={handlePick}
                handleRemovePick={handleRemovePick}
                maxPicks={poolInfo.max_picks}
                breaking={
                  fixtprop.data_type === 'boolean' ? null : (
                    <span className="prop-val"> {!fixtprop.value ? 'PD' : fixtprop.value}</span>
                  )
                }
              />
              <PickProp
                entryId={myEntry.entry_id}
                fixtureProp={fixtprop}
                type={'over'}
                isDisabled={isDisabled}
                selectedValue={selectedValue}
                handlePick={handlePick}
                handleRemovePick={handleRemovePick}
                maxPicks={poolInfo.max_picks}
                breaking={
                  fixtprop.data_type === 'boolean' ? null : (
                    <span className="prop-val"> {!fixtprop.value ? 'PD' : fixtprop.value}</span>
                  )
                }
              />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  };

  return (
    <div className="props-list">
      <form className="1">
        <div className="form-group">
          {groupTypesProps.map((group, index) => {
            return (
              <React.Fragment key={index}>
                <div key={index + 'bs'} className="titleProps row">
                  {group.name}
                </div>
                <ul className="lista-Props">
                  {group.props.map((prop) => {
                    return getPropsByGroup(prop);
                  })}
                </ul>
              </React.Fragment>
            );
          })}
        </div>
      </form>
    </div>
  );
};

class PicksProps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (!this.props.fixtureProps || !this.props.fixtureProps.length) {
      return null;
    }

    return (
      <div className="">
        <div className="flex-row title-quiniela sub">
          <span>PROPS</span>
        </div>
        <ListPicksProps
          fixtures={this.props.fixtures}
          fixtureProps={this.props.fixtureProps}
          poolInfo={this.props.poolInfo.pool}
          handlePick={this.props.handlePick}
          handleRemovePick={this.props.handleRemovePick}
          updateStartedFixture={this.props.updateStartedFixture}
          myEntry={this.props.myEntry}
        />
      </div>
    );
  }
}

PicksProps.propTypes = {
  fixtureProps: propTypes.array.isRequired,
  myEntry: propTypes.object,
  handlePick: propTypes.func.isRequired,
  handleRemovePick: propTypes.func.isRequired,
};

export default PicksProps;
